"use client"
import { Divider, Stack, Typography } from "@mui/material"

export const BuildVersionInfo = () => {
  const buildVersion = process.env.NEXT_PUBLIC_BUILD_VERSION || ""
  const environmentName = (
    process.env.NEXT_PUBLIC_ENV ||
    process.env.ENV ||
    ""
  ).toUpperCase()

  if (!environmentName || !buildVersion) return null

  return (
    <Stack direction="row" alignItems="center" spacing={1.5}>
      <Divider
        orientation="vertical"
        flexItem
        sx={{ borderColor: "text.secondary" }}
      />
      <Stack>
        <Typography variant="body2" color="mud.main">
          Environment: {environmentName}
        </Typography>
        <Typography variant="body2" color="mud.main">
          Version: {buildVersion}
        </Typography>
      </Stack>
    </Stack>
  )
}
